import Model from "./base/model";

class City extends Model {
  resourceName() {
    return "cities";
  }

  fields() {
    return {
      name: "",
      state_id: "",
      state: "",
      uf: "",
      latitude: "",
      longitude: "",
    };
  }
}
export default new City();
